import { Component } from '@angular/core';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { SessionService } from '../../../Util/Session/session.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-user-right',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule],
  templateUrl: './user-right.component.html',
  styleUrl: './user-right.component.scss'
})
export class UserRightComponent {
  isDisabled: boolean = false;
  user = [] as any;
  userRights = [] as any;
  userProfiles = [] as any;

  Rights = {
    SelectType: 'I',
    ProfileMasterId: null,
    ESS_ProfileUserRights: [] as any,
  }

  Filter = {
    ProfileMasterID: null as any,
  }
  constructor(
    private userright: UserRightService,
    private session: SessionService,
    private combo: ComboService,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    this.ComboLoad('ProfileMaster');
  }

  Validate(form: any, Name: any) {
    if (form.valid) {
      if (Name == 'UserRightForm') {
        this.ESS_ProfileMenuRights_SelectSelect();
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_ProfileMenuRights_SelectSelect() {
    this.isDisabled = true;
    this.userright.ESS_ProfileMenuRights_SelectSelect({ SelectType: 'S', ProfileMasterId: this.Filter.ProfileMasterID }).subscribe({
      next: (response) => {
        this.userRights = response;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_ProfileMenuRightsInsertUpdate() {
    this.Rights.ESS_ProfileUserRights = [];
    await this.common.getPageRights();
    if (this.common.PageRight.IsEdit || true) {
      if (this.Filter.ProfileMasterID > 0 && this.userRights.length > 0) {
        this.isDisabled = true;
        this.Rights.ProfileMasterId = this.Filter.ProfileMasterID;

        this.userRights.forEach((element: any) => {
          this.updateMenuVisibility(element);
        });

        // this.userRights.forEach((element: any) => {
        //   if (element['SubMenus'].length > 0) {
        //     this.Rights.ESS_ProfileUserRights.push({
        //       ESS_MenuMasterId: element['ESS_MenuMasterId'],
        //       IsView: element['SubMenus'].filter((e: any) => e.IsView).length > 0 ? true : false,
        //       IsEdit: element['IsEdit'],
        //       IsAdd: element['IsAdd'],
        //       IsDelete: element['IsDelete'],
        //       IsPrint: element['IsPrint'],
        //     });

        //     element['SubMenus'].forEach((element2: any) => {
        //       if (element2['SubMenus'].length > 0) {
        //         this.Rights.ESS_ProfileUserRights.push({
        //           ESS_MenuMasterId: element2['ESS_MenuMasterId'],
        //           IsView: element2['SubMenus'].filter((e: any) => e.IsView).length > 0 ? true : false,
        //           IsEdit: element2['IsEdit'],
        //           IsAdd: element2['IsAdd'],
        //           IsDelete: element2['IsDelete'],
        //           IsPrint: element2['IsPrint'],
        //         });
        //         element2['SubMenus'].forEach((element3: any) => {
        //           if (element3['SubMenus'].length > 0) {
        //             this.Rights.ESS_ProfileUserRights.push({
        //               ESS_MenuMasterId: element3['ESS_MenuMasterId'],
        //               IsView: element3['SubMenus'].filter((e: any) => e.IsView).length > 0 ? true : false,
        //               IsEdit: element3['IsEdit'],
        //               IsAdd: element3['IsAdd'],
        //               IsDelete: element3['IsDelete'],
        //               IsPrint: element3['IsPrint'],
        //             });

        //             element3['SubMenus'].forEach((element4: any) => {
        //               if (element4['SubMenus'].length > 0) {
        //                 this.Rights.ESS_ProfileUserRights.push({
        //                   ESS_MenuMasterId: element4['ESS_MenuMasterId'],
        //                   IsView: element4['SubMenus'].filter((e: any) => e.IsView).length > 0 ? true : false,
        //                   IsEdit: element4['IsEdit'],
        //                   IsAdd: element4['IsAdd'],
        //                   IsDelete: element4['IsDelete'],
        //                   IsPrint: element4['IsPrint'],
        //                 });

        //                 element4['SubMenus'].forEach((element5: any) => {
        //                   if (element5['SubMenus'].length > 0) {
        //                     this.Rights.ESS_ProfileUserRights.push({
        //                       ESS_MenuMasterId: element5['ESS_MenuMasterId'],
        //                       IsView: element5['SubMenus'].filter((e: any) => e.IsView).length > 0 ? true : false,
        //                       IsEdit: element5['IsEdit'],
        //                       IsAdd: element5['IsAdd'],
        //                       IsDelete: element5['IsDelete'],
        //                       IsPrint: element5['IsPrint'],
        //                     });

        //                     element5['SubMenus'].forEach((element6: any) => {
        //                       if (element6['SubMenus'].length > 0) {
        //                         this.Rights.ESS_ProfileUserRights.push({
        //                           ESS_MenuMasterId: element6['ESS_MenuMasterId'],
        //                           IsView: element6['SubMenus'].filter((e: any) => e.IsView).length > 0 ? true : false,
        //                           IsEdit: element6['IsEdit'],
        //                           IsAdd: element6['IsAdd'],
        //                           IsDelete: element6['IsDelete'],
        //                           IsPrint: element6['IsPrint'],
        //                         });

        //                         element6['SubMenus'].forEach((element7: any) => {
        //                           if (element7['SubMenus'].length > 0) {
        //                             this.Rights.ESS_ProfileUserRights.push({
        //                               ESS_MenuMasterId: element7['ESS_MenuMasterId'],
        //                               IsView: element7['SubMenus'].filter((e: any) => e.IsView).length > 0 ? true : false,
        //                               IsEdit: element7['IsEdit'],
        //                               IsAdd: element7['IsAdd'],
        //                               IsDelete: element7['IsDelete'],
        //                               IsPrint: element7['IsPrint'],
        //                             });
        //                           } else {
        //                             this.Rights.ESS_ProfileUserRights.push({
        //                               ESS_MenuMasterId: element6['ESS_MenuMasterId'],
        //                               IsView: element7['IsView'],
        //                               IsEdit: element7['IsEdit'],
        //                               IsAdd: element7['IsAdd'],
        //                               IsDelete: element7['IsDelete'],
        //                               IsPrint: element7['IsPrint'],
        //                             });
        //                           }
        //                         })
        //                       } else {
        //                         this.Rights.ESS_ProfileUserRights.push({
        //                           ESS_MenuMasterId: element6['ESS_MenuMasterId'],
        //                           IsView: element6['IsView'],
        //                           IsEdit: element6['IsEdit'],
        //                           IsAdd: element6['IsAdd'],
        //                           IsDelete: element6['IsDelete'],
        //                           IsPrint: element6['IsPrint'],
        //                         });
        //                       }
        //                     });
        //                   } else {
        //                     this.Rights.ESS_ProfileUserRights.push({
        //                       ESS_MenuMasterId: element4['ESS_MenuMasterId'],
        //                       IsView: element5['IsView'],
        //                       IsEdit: element5['IsEdit'],
        //                       IsAdd: element5['IsAdd'],
        //                       IsDelete: element5['IsDelete'],
        //                       IsPrint: element5['IsPrint'],
        //                     });
        //                   }
        //                 })
        //               } else {
        //                 this.Rights.ESS_ProfileUserRights.push({
        //                   ESS_MenuMasterId: element4['ESS_MenuMasterId'],
        //                   IsView: element4['IsView'],
        //                   IsEdit: element4['IsEdit'],
        //                   IsAdd: element4['IsAdd'],
        //                   IsDelete: element4['IsDelete'],
        //                   IsPrint: element4['IsPrint'],
        //                 });
        //               }
        //             })
        //           } else {
        //             this.Rights.ESS_ProfileUserRights.push({
        //               ESS_MenuMasterId: element3['ESS_MenuMasterId'],
        //               IsView: element3['IsView'],
        //               IsEdit: element3['IsEdit'],
        //               IsAdd: element3['IsAdd'],
        //               IsDelete: element3['IsDelete'],
        //               IsPrint: element3['IsPrint'],
        //             });
        //           }
        //         });
        //       } else {
        //         this.Rights.ESS_ProfileUserRights.push({
        //           ESS_MenuMasterId: element2['ESS_MenuMasterId'],
        //           IsView: element2['IsView'],
        //           IsEdit: element2['IsEdit'],
        //           IsAdd: element2['IsAdd'],
        //           IsDelete: element2['IsDelete'],
        //           IsPrint: element2['IsPrint'],
        //         });
        //       }
        //     });
        //   } else {
        //     this.Rights.ESS_ProfileUserRights.push({
        //       ESS_MenuMasterId: element['ESS_MenuMasterId'],
        //       IsView: element['IsView'],
        //       IsEdit: element['IsEdit'],
        //       IsAdd: element['IsAdd'],
        //       IsDelete: element['IsDelete'],
        //       IsPrint: element['IsPrint'],
        //     });
        //   }
        // });

        // try {
        //   if (this.Rights.ESS_ProfileUserRights.filter((e: any) => (e.ESS_MenuMasterId == 61 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 64 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 66 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 75 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 75 && e.IsView)).length > 0) {
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 59)[0].IsView = true;
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 58)[0].IsView = true;
        //   }
        // } catch (e) { }

        // try {
        //   if (this.Rights.ESS_ProfileUserRights.filter((e: any) => (e.ESS_MenuMasterId == 68 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 71 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 73 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 78 && e.IsView)).length > 0) {
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 60)[0].IsView = true;
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 58)[0].IsView = true;
        //   }
        // } catch (e) { }

        // try {
        //   if (this.Rights.ESS_ProfileUserRights.filter((e: any) => (e.ESS_MenuMasterId == 166 && e.IsView)).length > 0) {
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 165)[0].IsView = true;
        //   }
        // } catch (e) { }
        // try {
        //   if (this.Rights.ESS_ProfileUserRights.filter((e: any) => (e.ESS_MenuMasterId == 300 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 112 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 132 && e.IsView)).length > 0) {
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 299)[0].IsView = true;
        //   }
        // } catch (e) { }
        // try {
        //   if (this.Rights.ESS_ProfileUserRights.filter((e: any) => (e.ESS_MenuMasterId == 299 && e.IsView)).length > 0) {
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 3)[0].IsView = true;
        //   }
        // } catch (e) { }
        // try {
        //   if (this.Rights.ESS_ProfileUserRights.filter((e: any) => (e.ESS_MenuMasterId == 48 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 49 && e.IsView) || (e.ESS_MenuMasterId == 52 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 53 && e.IsView) || (e.ESS_MenuMasterId == 165 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 274 && e.IsView) || (e.ESS_MenuMasterId == 157 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 158 && e.IsView) || (e.ESS_MenuMasterId == 159 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 160 && e.IsView) || (e.ESS_MenuMasterId == 163 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 164 && e.IsView) || (e.ESS_MenuMasterId == 166 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 171 && e.IsView) || (e.ESS_MenuMasterId == 275 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 276 && e.IsView) || (e.ESS_MenuMasterId == 167 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 168 && e.IsView) || (e.ESS_MenuMasterId == 172 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 173 && e.IsView) || (e.ESS_MenuMasterId == 268 && e.IsView) ||
        //     (e.ESS_MenuMasterId == 269 && e.IsView)).length > 0) {
        //     this.Rights.ESS_ProfileUserRights.filter((e: any) => e.ESS_MenuMasterId == 39)[0].IsView = true;
        //   }
        // } catch (e) { }
        
        this.userright.ESS_ProfileMenuRightsInsertUpdate(this.Rights).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              this.Rights.ESS_ProfileUserRights = [];
              this.ESS_ProfileMenuRights_SelectSelect();
            } else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  updateMenuVisibility(menu: any): boolean {
    if (menu.SubMenus && menu.SubMenus.length > 0) {
      let hasVisibleChild = false;
      let hasanyVisibleChild = false;

      for (const child of menu.SubMenus) {
        const childVisible = this.updateMenuVisibility(child);
        if (childVisible) {
          hasVisibleChild = true;
          hasanyVisibleChild = true;

          if (this.Rights.ESS_ProfileUserRights.findIndex((e: any) => e.ESS_MenuMasterId == child.ESS_MenuMasterId) < 0) {
            this.Rights.ESS_ProfileUserRights.push({
              ESS_MenuMasterId: child.ESS_MenuMasterId,
              IsView: child.IsView,
              IsEdit: child.IsEdit,
              IsAdd: child.IsAdd,
              IsDelete: child.IsDelete,
              IsPrint: child.IsPrint,
            });
          }
        }
      }
      if (hasanyVisibleChild) {
        if (this.Rights.ESS_ProfileUserRights.findIndex((e: any) => e.ESS_MenuMasterId == menu.ESS_MenuMasterId) < 0) {
          this.Rights.ESS_ProfileUserRights.push({
            ESS_MenuMasterId: menu.ESS_MenuMasterId,
            IsView: true,
            IsEdit: menu.IsEdit,
            IsAdd: menu.IsAdd,
            IsDelete: menu.IsDelete,
            IsPrint: menu.IsPrint,
          });
        }
      }
      menu.IsView = hasVisibleChild;
      return menu.IsView;
    } else {
      // This is a last level menu, return its own visibility
      if (menu.IsView) {
        if (this.Rights.ESS_ProfileUserRights.findIndex((e: any) => e.ESS_MenuMasterId == menu.ESS_MenuMasterId) < 0) {
          this.Rights.ESS_ProfileUserRights.push({
            ESS_MenuMasterId: menu.ESS_MenuMasterId,
            IsView: true,
            IsEdit: menu.IsEdit,
            IsAdd: menu.IsAdd,
            IsDelete: menu.IsDelete,
            IsPrint: menu.IsPrint,
          });
        }
      }
      return menu.IsView;
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': this.user.UserId, 'EmpType': this.user.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'ProfileMaster') {
          if (response.ComboLoad.length > 0) {
            this.userProfiles = response.ComboLoad;
          }

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  clear() {
    this.userRights = [];
  }

  ViewCheck(menu: any) {
    if (!menu['IsView']) {
      menu['IsView'] = true;
    }
  }

  ViewUnCheck(menu: any, event: any) {
    if (!event.target.checked) {
      menu['IsAdd'] = false;
      menu['IsEdit'] = false;
      menu['IsDelete'] = false;
      menu['IsPrint'] = false;
    }
  }

  CheckAll(type: String, event: any) {
    if (type == 'View') {
      this.userRights.forEach((element: any) => {
        if (element['SubMenus'].length > 0) {
          element['SubMenus'].forEach((element2: any) => {
            if (element2['SubMenus'].length > 0) {
              element2['SubMenus'].forEach((element3: any) => {
                if (element3['SubMenus'].length > 0) {
                  element3['SubMenus'].forEach((element4: any) => {
                    element4['IsView'] = event.target.checked;
                    if (!event.target.checked) {
                      element4['IsAdd'] = event.target.checked;
                      element4['IsEdit'] = event.target.checked;
                      element4['IsDelete'] = event.target.checked;
                      element4['IsPrint'] = event.target.checked;
                    }
                  })
                } else {
                  element3['IsView'] = event.target.checked;
                  if (!event.target.checked) {
                    element3['IsAdd'] = event.target.checked;
                    element3['IsEdit'] = event.target.checked;
                    element3['IsDelete'] = event.target.checked;
                    element3['IsPrint'] = event.target.checked;
                  }
                }
              });
            } else {
              element2['IsView'] = event.target.checked;
              if (!event.target.checked) {
                element2['IsAdd'] = event.target.checked;
                element2['IsEdit'] = event.target.checked;
                element2['IsDelete'] = event.target.checked;
                element2['IsPrint'] = event.target.checked;
              }
            }
          });
        } else {
          element['IsView'] = event.target.checked;
          if (!event.target.checked) {
            element['IsAdd'] = event.target.checked;
            element['IsEdit'] = event.target.checked;
            element['IsDelete'] = event.target.checked;
            element['IsPrint'] = event.target.checked;
          }
        }
      });
    } else if (type == 'Add') {
      this.userRights.forEach((element: any) => {
        if (element['SubMenus'].length > 0) {
          element['SubMenus'].forEach((element2: any) => {
            if (element2['SubMenus'].length > 0) {
              element2['SubMenus'].forEach((element3: any) => {
                if (element3['SubMenus'].length > 0) {
                  element3['SubMenus'].forEach((element4: any) => {
                    if (element4['AddApplicable']) {
                      element4['IsAdd'] = event.target.checked;
                      if (event.target.checked) {
                        element4['IsView'] = event.target.checked;
                      }
                    }
                  })
                } else {
                  if (element3['AddApplicable']) {
                    element3['IsAdd'] = event.target.checked;
                    if (event.target.checked) {
                      element3['IsView'] = event.target.checked;
                    }
                  }
                }
              });
            } else {
              if (element2['AddApplicable']) {
                element2['IsAdd'] = event.target.checked;
                if (event.target.checked) {
                  element2['IsView'] = event.target.checked;
                }
              }
            }
          });
        } else {
          if (element['AddApplicable']) {
            element['IsAdd'] = event.target.checked;
            if (event.target.checked) {
              element['IsView'] = event.target.checked;
            }
          }
        }
      });
    } else if (type == 'Edit') {
      this.userRights.forEach((element: any) => {
        if (element['SubMenus'].length > 0) {
          element['SubMenus'].forEach((element2: any) => {
            if (element2['SubMenus'].length > 0) {
              element2['SubMenus'].forEach((element3: any) => {
                if (element3['SubMenus'].length > 0) {
                  element3['SubMenus'].forEach((element4: any) => {
                    if (element4['EditApplicable']) {
                      element4['IsEdit'] = event.target.checked;
                      if (event.target.checked) {
                        element4['IsView'] = event.target.checked;
                      }
                    }
                  })
                } else {
                  if (element3['EditApplicable']) {
                    element3['IsEdit'] = event.target.checked;
                    if (event.target.checked) {
                      element3['IsView'] = event.target.checked;
                    }
                  }
                }
              });
            } else {
              if (element2['EditApplicable']) {
                element2['IsEdit'] = event.target.checked;
                if (event.target.checked) {
                  element2['IsView'] = event.target.checked;
                }
              }
            }
          });
        } else {
          if (element['EditApplicable']) {
            element['IsEdit'] = event.target.checked;
            if (event.target.checked) {
              element['IsView'] = event.target.checked;
            }
          }
        }
      });
    } else if (type == 'Delete') {
      this.userRights.forEach((element: any) => {
        if (element['SubMenus'].length > 0) {
          element['SubMenus'].forEach((element2: any) => {
            if (element2['SubMenus'].length > 0) {
              element2['SubMenus'].forEach((element3: any) => {
                if (element3['SubMenus'].length > 0) {
                  element3['SubMenus'].forEach((element4: any) => {
                    if (element4['DeleteApplicable']) {
                      element4['IsDelete'] = event.target.checked;
                      if (event.target.checked) {
                        element4['IsView'] = event.target.checked;
                      }
                    }
                  })
                } else {
                  if (element3['DeleteApplicable']) {
                    element3['IsDelete'] = event.target.checked;
                    if (event.target.checked) {
                      element3['IsView'] = event.target.checked;
                    }
                  }
                }
              });
            } else {
              if (element2['DeleteApplicable']) {
                element2['IsDelete'] = event.target.checked;
                if (event.target.checked) {
                  element2['IsView'] = event.target.checked;
                }
              }
            }
          });
        } else {
          if (element['DeleteApplicable']) {
            element['IsDelete'] = event.target.checked;
            if (event.target.checked) {
              element['IsView'] = event.target.checked;
            }
          }
        }
      });
    } else if (type == 'Print') {
      this.userRights.forEach((element: any) => {
        if (element['SubMenus'].length > 0) {
          element['SubMenus'].forEach((element2: any) => {
            if (element2['SubMenus'].length > 0) {
              element2['SubMenus'].forEach((element3: any) => {
                if (element3['SubMenus'].length > 0) {
                  element3['SubMenus'].forEach((element4: any) => {
                    if (element4['PrintApplicable']) {
                      element4['IsPrint'] = event.target.checked;
                      if (event.target.checked) {
                        element4['IsView'] = event.target.checked;
                      }
                    }
                  })
                } else {
                  if (element3['PrintApplicable']) {
                    element3['IsPrint'] = event.target.checked;
                    if (event.target.checked) {
                      element3['IsView'] = event.target.checked;
                    }
                  }
                }
              });
            } else {
              if (element2['PrintApplicable']) {
                element2['IsPrint'] = event.target.checked;
                if (event.target.checked) {
                  element2['IsView'] = event.target.checked;
                }
              }
            }
          });
        } else {
          if (element['PrintApplicable']) {
            element['IsPrint'] = event.target.checked;
            if (event.target.checked) {
              element['IsView'] = event.target.checked;
            }
          }
        }
      });
    }
  }
}
